/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: index.ts
 * Class: index.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { ContractLocationsState } from './types';
import { RootState } from '../types';

export const state: ContractLocationsState = {
  contractLocations: undefined,
  error: false,
};

const namespaced = true;

export const locations: Module<ContractLocationsState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
